import ajax from "./ajax";

export function getFrontendSettings() {
  return ajax("/settings?SettingsSearch[module_name]=frontend&per-page=1000");
}
